import { render, staticRenderFns } from "./receivingDate.vue?vue&type=template&id=3ddd36af&"
import script from "./receivingDate.vue?vue&type=script&lang=js&"
export * from "./receivingDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports